import React from 'react';
import { Typography, Row, Col, Divider } from 'antd';

import {
  DollarOutlined,
  ShopOutlined,
  HeartOutlined,
  BookOutlined,
  TeamOutlined,
  ExperimentOutlined,
  RiseOutlined,
  BuildOutlined,
  SwapOutlined,
  HomeOutlined,
  ReloadOutlined,
  CloudOutlined,
  GlobalOutlined,
  EnvironmentOutlined,
} from '@ant-design/icons';

import '../../../Styles/ResearchLabs.css';

const { Title, Paragraph } = Typography;


/* =========================================================
   RESEARCH DOMAINS
   ========================================================= */

const researchDomains = [
  {
    domain: 'Domain 1 – Water',
    description: [
      ' To develop mechanism for determining regional scale water availability, stress and diversions from PRSS satellite imagery . To formulate PRSS satellite-based techniques for assessing actual crop-water use and projecting agricultural water shortages . To develop digital image processing protocols for pattern recognition and change detection in regional scale snow covers, precipitation and soil-moisture 4. To develop framework at basin level equitable water allocations and distribution for irrigated agriculture',
    ],
  },

  {
    domain: 'Domain 2 – Soil',
    description: [
      ' To develop techniques to synthesize high resolution soil moisture maps using PRSS satellite imagery . To upscale existing GIS based soil maps of Punjab using PRSS satellite information for agricultural areas of irrigated Indus Basin',
    ],
  },

  {
    domain: 'Domain 3 – Crops',
    description: [
      ' To develop satellite-imagery integrated mechanistic models for Crop-water productivity mapping. To improve crop coefficients in variable agro-ecological zones of the country using newly available PRSS satellite imagery. To improve existing crop models by integrating satellite-imagery for regional scale agro-ecosystems modelling and yield estimates',
    ],
  },
];


/* =========================================================
   FOCUSED SDGs
   ========================================================= */

const focusedSdgs = [
  {
    label: 'No Poverty',
    icon: DollarOutlined,
  },
  {
    label: 'Zero Hunger',
    icon: ShopOutlined,
  },
  {
    label: 'Good Health and Wellbeing',
    icon: HeartOutlined,
  },
  {
    label: 'Quality Education',
    icon: BookOutlined,
  },
  {
    label: 'Gender Equality',
    icon: TeamOutlined,
  },
  {
    label: 'Clean Water and Sanitation',
    icon: ExperimentOutlined,
  },
  {
    label: 'Decent Work and Economic Growth',
    icon: RiseOutlined,
  },
  {
    label: 'Industry, Innovation and Infrastructure',
    icon: BuildOutlined,
  },
  {
    label: 'Reduced Inequality',
    icon: SwapOutlined,
  },
  {
    label: 'Sustainable Cities and Communities',
    icon: HomeOutlined,
  },
  {
    label: 'Responsible Consumption and Production',
    icon: ReloadOutlined,
  },
  {
    label: 'Climate Action',
    icon: CloudOutlined,
  },
  {
    label: 'Life Below Water',
    icon: GlobalOutlined,
  },
  {
    label: 'Life On Land',
    icon: EnvironmentOutlined,
  },
];


/* =========================================================
   COMPONENT
   ========================================================= */

const ArslDomain = () => {
  return (
    <section className="research-domains-section sdssl-research-domains-section">

      <div className="research-domains-inner">

        <Row
          gutter={[72, 44]}
          justify="space-between"
        >

          {/* =================================================
              RESEARCH DOMAINS
              ================================================= */}

          <Col xs={24} lg={15}>

            <Title
              level={2}
              className="research-domains-title"
            >
              Research Domains
            </Title>

            <Divider className="ncgsa-divider" />


            {researchDomains.map(({ domain, description }) => (

              <article
                className="research-domain"
                key={domain}
              >

                <Title
                  level={4}
                  className="research-domain-title"
                >
                  {domain}
                </Title>


                {description.map((text, index) => (

                  <Paragraph
                    className="research-domain-copy"
                    key={`${domain}-${index}`}
                  >
                    {text}
                  </Paragraph>

                ))}

              </article>

            ))}

          </Col>


          {/* =================================================
              FOCUSED SDGs
              ================================================= */}

          <Col xs={24} lg={8}>

            <Title
              level={2}
              className="research-domains-title"
            >
              Focused SDGs
            </Title>

            <Divider className="ncgsa-divider" />


            <ul className="sdg-focus-list">

              {focusedSdgs.map(({ label, icon: Icon }) => (

                <li key={label}>

                  <span
                    className="sdg-focus-icon"
                    aria-hidden="true"
                  >
                    <Icon />
                  </span>

                  <span>
                    {label}
                  </span>

                </li>

              ))}

            </ul>

          </Col>

        </Row>

      </div>

    </section>
  );
};


export default ArslDomain;